import React, { ReactNode, useEffect, useState } from 'react';
import { styles } from "./styles";
import { styled, useTheme } from '@mui/material/styles';
import SmallLogo from "assets/icons/SmallLogo.svg";
import LargeLogo from "assets/icons/LargeLogo.svg";
import {
  Box,
  Drawer,
  CssBaseline,
  Toolbar,
  IconButton,
  Typography,
  Grid
} from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MuiSelect from 'components/MuiSelect/MuiSelect';
import {getAllUsers, getAllRoles, getRolePermissions, getUserPermissions} from 'apis/user';
import {dashRoutes, deviceRoutes, adminRoutes, truckRoutes, tagSchemeRoutes, reportRoutes} from 'utils/routes';
import { NavLink, Navigate } from "react-router-dom";
import CommonUtil from "../../common/CommonUtil";
import LoginPopup from 'common/LoginPopup';
import { useNavigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";



const drawerWidth = 265;
let prmissions = [{"masterPermissionId":2,"applicationName":"Configuration Manager","moduleName":"Administration","screenName":"Roles","addPermission":true,"editPermission":true},
  {"masterPermissionId":4,"applicationName":"Configuration Manager","moduleName":"Administration","screenName":"Tag Scheme Manager","addPermission":true,"editPermission":true},
  {"masterPermissionId":1,"applicationName":"Configuration Manager","moduleName":"Administration","screenName":"User Management","addPermission":true,"editPermission":true},
  {"masterPermissionId":5,"applicationName":"Configuration Manager","moduleName":"Dashboard","screenName":"At a Glance","addPermission":false,"editPermission":true},
  {"masterPermissionId":3,"applicationName":"Configuration Manager","moduleName":"Device Management","screenName":"Device Manager","addPermission":true,"editPermission":true},
  {"masterPermissionId":9,"applicationName":"Configuration Manager","moduleName":"Truck Management","screenName":"Truck Manager","addPermission":false,"editPermission":true},
  {"masterPermissionId":6,"applicationName":"Vision","moduleName":"Reports","screenName":"Device Status Report","addPermission":true,"editPermission":true},
  {"masterPermissionId":7,"applicationName":"Vision","moduleName":"Reports","screenName":"Device Events Report","addPermission":true,"editPermission":true},
  {"masterPermissionId":8,"applicationName":"Vision","moduleName":"Reports","screenName":"Device Events Failed To Process Report","addPermission":true,"editPermission":true},
  {"masterPermissionId":10,"applicationName":"Vision","moduleName":"Reports","screenName":"Tip Push Status Report","addPermission":true,"editPermission":true},
  // {"masterPermissionId":11,"applicationName":"Vision","moduleName":"Reports","screenName":"At a Glance","addPermission":true,"editPermission":true},
  {"masterPermissionId":11,"applicationName":"Vision","moduleName":"Reports","screenName":"Missing Device Event Report","addPermission":true,"editPermission":true}
];


const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{ open?: boolean; }>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(1),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-191px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));


interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
  children?: ReactNode;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const getuserRoles = async () => {
  //let data = await getRolePermissions();

  //console.log(data);
  //localStorage.setItem('data', JSON.stringify(fakeUser));
}

let SName:any = null;
const PersistentDrawerLeft: React.FC<AppBarProps> = ({ children }) => {
  const { instance, accounts } = useMsal();
  const Navigate = useNavigate();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [isDBVisible,setDBVisible] = useState(false);
  const [isReportsVisible,setReportsVisible] = useState(false);
  const [isRolesVisible,setRolesVisible] = useState(false);
  const [isUserVisible,setUserVisible] = useState(false);
  const [isTagSchemeVisible,setTagSchemeVisible] = useState(false);
  const [isDeviceStatusVisible,setDeviceStatusVisible] = useState(false);
  const [isDeviceMgnrVisible,setDeviceMgnrVisible] = useState(false);
  const [isTruckMgnrVisible,setTruckMgnrVisible] = useState(false);
  const [isDeviceEventsVisible,setDeviceEventsVisible] = useState(false);
  const [isTagStatusVisible,setTagStatusVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [isDeviceMenuVisible,setDeviceMenuVisible] = useState(false);
  const [isAdminMenuVisible,setAdminMenuVisible] = useState(false);

  useEffect(() => {
    getuserRoles();
    getAllPermissions();
    CheckUserAccess();
  }, []);


  const CheckUserAccess = async() => {
    let data = await getUserPermissions();
    console.log(data);
    if(data){
      if(data?.response?.data?.errorMessage === 'User not found.') {
        setShowModal(true);
        closeErrorPopup();
      }
    }
  }

  const getAllPermissions = async () => {
    prmissions =  await getUserPermissions();
    console.log(prmissions);
    CommonUtil.PERMISSION_DATA = prmissions;
    if(prmissions && prmissions.length == 0){
      setShowModal(true);
    }else if(!prmissions){
      setShowModal(true);
    }
    prmissions.forEach((pItem:any,idx:number)=>{
      if(pItem && (pItem.addPermission || pItem.editPermission)){
        if(pItem.screenName == CommonUtil.ROLES){
          setRolesVisible(true);
          setAdminMenuVisible(true);
        }else if(pItem.screenName == CommonUtil.TAG_SCHEME_MANAGER){
          setTagSchemeVisible(true);
         // setDeviceMenuVisible(true);
        }else if(pItem.screenName == CommonUtil.USER_MANAGEMENT){//"User Management"
          setUserVisible(true);
          setAdminMenuVisible(true);
        }else if(pItem.screenName == CommonUtil.AT_A_GLANCE){//"At a Glance"
          setDBVisible(true);
        }else if(pItem.screenName == CommonUtil.DEVICE_MANAGER){//"Device Manager"
          setDeviceMgnrVisible(true);
          setDeviceMenuVisible(true);
        }else if(pItem.screenName == CommonUtil.TRUCK_MANAGER){//"Truck Manager"
          setTruckMgnrVisible(true);
          setTruckMgnrVisible(true);
        }else if(pItem.screenName == CommonUtil.DEVICE_EVENTS){//"Device Events"
          setDeviceEventsVisible(true);
          setReportsVisible(true);
        }else if(pItem.screenName == CommonUtil.DEVICE_STATUS){//"Device Status"
          setDeviceStatusVisible(true);
          setReportsVisible(true);
        }else if(pItem.screenName == CommonUtil.TAG_STATUS){//"Tag Status"
          setTagStatusVisible(true);
          setReportsVisible(true);
        }else if(pItem.screenName == CommonUtil.TAG_EVENTS_FAILED){//"Tag Status"
          setTagStatusVisible(true);
          setReportsVisible(true);
        }
      }
    })
  }

  let isScreenAvailable = (scrName:string):boolean=>{
    let flag:boolean = false;
    for(let idx:number = 0;idx<prmissions.length;idx++){
      let pItem = prmissions[idx];
      if(pItem && pItem.addPermission && pItem.editPermission){
        if(pItem.screenName == scrName){
          return true;
        }
      }
    }

    return flag;
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const closeErrorPopup = () => {
    setTimeout(() => {
      setShowModal(false);
      Navigate('/Login');
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/" // redirects the top level app after logout
      });
    }, 2500)
  }

  //console.log("filtered is" + filtered);

  return (
    <Box sx={{ display: 'flex' }}>
      {showModal ? <LoginPopup title='Data' popupText='You do not have permissions. Please contact your Admin' open={showModal} handlePopupClose={closeErrorPopup}></LoginPopup> : ""}
      <CssBaseline />
      {!open &&
        <AppBar position="fixed" open={open} sx={styles.bar}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={styles.toolbar}
            >
              <img src={SmallLogo} alt="" />
              <ChevronRightIcon sx={styles.drawerIcon} />
            </IconButton>
          </Toolbar>
        </AppBar>
      }
      <Drawer
        PaperProps={{
          sx: {
            border: "none !important",
            boxShadow: "0px 4px 8px rgba(16, 24, 64, 0.08)"
          }
        }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader sx={styles.drawerHeader}>
          <img src={LargeLogo} alt="" />
          <ChevronLeftIcon sx={{ ...styles.drawerIcon, marginTop: 0 }} onClick={handleDrawerClose} />
        </DrawerHeader>
        <Grid item xs={12} sx={styles.contentContainer}>
          <Typography sx={{ ...styles.headerText, marginTop: "1.5rem" }} style={{display:(isDBVisible?"":"none")}}>DASHBOARD</Typography>
          {dashRoutes.map((d, i) =>
            <div className="nav-link" key={i} style={{display:(isDBVisible?"":"none")}}>
               <NavLink
                  to={d.route}
                  style={
                    ({ isActive }) => (
                      isActive
                        ? styles.activeLink
                        : styles.link
                    )
                  }
                >
                  {d.header}
                </NavLink>

            </div>
          )}
          <Typography sx={{ ...styles.headerText, marginTop: "1.5rem" }} style={{display:(isDeviceMenuVisible?"":"none")}}>DEVICE MANAGEMENT</Typography>
          {deviceRoutes && deviceRoutes.map((r,i) =>

              (<div className="nav-link" key={i} style={{display:(CommonUtil.isScreenAvailable(r.name)?"":"none")}}>
              <NavLink
              to={r.route}
              style={
                ({ isActive }) => (
                  isActive
                    ? styles.activeLink
                    : styles.link
                )
              }
            >
              {r.header}
            </NavLink>
             </div>)
          )}

          <Typography sx={{ ...styles.headerText, marginTop: "1.5rem" }} style={{display:(isTruckMgnrVisible?"":"none")}}>TRUCK MANAGEMENT</Typography>
          {truckRoutes && truckRoutes.map((r,i) =>

              (<div className="nav-link" key={i} style={{display:(CommonUtil.isScreenAvailable(r.name)?"":"none")}}>
                <NavLink
                    to={r.route}
                    style={
                      ({ isActive }) => (
                          isActive
                              ? styles.activeLink
                              : styles.link
                      )
                    }
                >
                  {r.header}
                </NavLink>
              </div>)
          )}
          <Typography sx={{ ...styles.headerText, marginTop: "1.5rem" }} style={{display:(isTagSchemeVisible?"":"none")}}>TAG SCHEME MANAGEMENT</Typography>
          {tagSchemeRoutes && tagSchemeRoutes.map((r,i) =>

              (<div className="nav-link" key={i} style={{display:(CommonUtil.isScreenAvailable(r.name)?"":"none")}}>
                <NavLink
                    to={r.route}
                    style={
                      ({ isActive }) => (
                          isActive
                              ? styles.activeLink
                              : styles.link
                      )
                    }
                >
                  {r.header}
                </NavLink>
              </div>)
          )}

          <Typography sx={{ ...styles.headerText, marginTop: "1.5rem" }} style={{display:(isReportsVisible?"":"none")}}>REPORTS</Typography>
          {reportRoutes && reportRoutes.map((r,i) =>

              (<div className="nav-link" key={i} style={{display:(CommonUtil.isScreenAvailable(r.name)?"":"none")}}>
                <NavLink
                    to={r.route}
                    style={
                      ({ isActive }) => (
                          isActive
                              ? styles.activeLink
                              : styles.link
                      )
                    }
                >
                  {r.header}
                </NavLink>
              </div>)
          )}

          {/* {deviceRoutes.map((d:any, i) =>
            <div className="nav-link" key={i}>
              <NavLink
              to={d.route}
              style={
                ({ isActive }) => (
                  isActive
                    ? styles.activeLink
                    : styles.link
                )
              }
            >
              {d.name}
            </NavLink>
             </div>
          )} */}
          <Typography sx={{ ...styles.headerText, marginTop: "1.5rem" }} style={{display:(isAdminMenuVisible?"":"none")}}>ADMINISTRATION</Typography>
          {adminRoutes.map((d, i) =>
            <div className="nav-link" key={i} style={{display:(isAdminMenuVisible?"":"none")}}>
              <NavLink
                to={d.route}
                style={
                  ({ isActive }) => (
                    isActive
                      ? styles.activeLink
                      : styles.link
                  )
                }
              >
                {d.header}
              </NavLink>
            </div>
          )}
        </Grid>
      </Drawer>
      <Main open={open} sx={styles.content}>
        {children}
      </Main>
    </Box>
  );
}

export default PersistentDrawerLeft;
